export enum CatalogSortingTypes {
  Normal = 'normal',
  PriceASC = 'price_asc',
  PriceDESC = 'price_desc',
  AgeASC = 'age_asc',
  AgeDESC = 'age_desc',
  ExpASC = 'exp_asc',
  ExpDESC = 'exp_desc',
  ReviewASC = 'review_asc',
  ReviewDESC = 'review_desc',
}
